var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(.3)"},[React.createElement("rect",{"width":"29","height":"28","opacity":".7","rx":"5","transform":"translate(-.3)","key":0}),React.createElement("path",{"fill":"#fff","d":"M14.7 23.6v-4.2c0-.5-.2-.8-.8-.7h-2.1c-.5 0-.8-.1-.8-.7v-2.7c0-.5.2-.7.7-.7h2c.7 0 1-.2 1-1v-3a4.7 4.7 0 0 1 4.5-4.7 24.4 24.4 0 0 1 3.6.1c.4 0 .6.2.6.6V9c0 .5-.3.6-.7.6a12.1 12.1 0 0 0-1.6 0 1.9 1.9 0 0 0-1.8 1.8A21.5 21.5 0 0 0 19 14c0 .5.4.6.8.6h2.5c.5 0 .8.1.6.7a23.4 23.4 0 0 0-.3 2.5c0 .6-.3 1-1 .9H20c-.7 0-.9.2-.9.9V28c0 .4-.1.6-.5.6h-3.3c-.6 0-.6-.4-.6-.8v-4.3Z","key":1})]));
}

Facebook.defaultProps = {"viewBox":"0 0 29 28.7"};

module.exports = Facebook;

Facebook.default = Facebook;
